import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Checkbox, notification, Progress, Slider } from 'antd';
import { cleanFirebaseId } from '../../lib/utils';
import { editChallengeUserBook } from '../../actions';

class ReadingChallengeProgress extends Component {
    render() {
        const { readingChallengesUser, readingChallenges, challengeId, showPercent } = this.props;
        const readingChallengeUser = readingChallengesUser[challengeId] || {};
        // const podcastDone = readingChallengeUser[podcast.collectionId];
        // console.dir(readingChallengeUser);
        const sliderValue = 100 * Object.keys(readingChallengeUser).length /
            Object.keys((readingChallenges[challengeId] ?? {})['collectionIds'] || {}).length;
        console.dir(Object.keys(readingChallengeUser).length);
        console.dir(readingChallenges[challengeId]);
        console.dir(Object.keys(readingChallenges[challengeId] ?? {}).length);
        console.dir(sliderValue);
        return (
            <div
                style={{

                }}>
                <Progress
                    percent={sliderValue} showInfo={showPercent} />
            </div>
        )
    }
}

ReadingChallengeProgress.propTypes = {
    // podcast: PropTypes.object,
    // personalReads: PropTypes.object,
    // personalValues: PropTypes.object,
    readingChallenges: PropTypes.object,
    readingChallengesUser: PropTypes.object,
    challengeId: PropTypes.string,
    showPercent: PropTypes.bool,
    // day: PropTypes.number,
    // editChallengeUserBook: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        readingChallenges: state.readingChallenges,
        readingChallengesUser: state.readingChallengesUser,
        // personalReads: state.personalReads,
        // personalValues: state.personalValues,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        editChallengeUserBook: bindActionCreators(editChallengeUserBook, dispatch),
    }
};

// export default withRedux(initStore, null, null)(Home);
// export default compose(
//   withRedux(initStore, null, null),
//   connect(mapStateToProps, mapDispatchToProps)
// )(Home);

export default connect(mapStateToProps, mapDispatchToProps)(ReadingChallengeProgress);
